import React from "react";

import { Alert } from "~/components/alert";

import { DocLink } from "../../../../../../../components/react/docLink/DocLink";
import { SILENCING_DOC_LINK_SLUG } from "../../silencing-doc-link-slug";
import { useUnmuteDrawerContext } from "../context";
export function ActiveRulesAlert() {
	const { ruleCount } = useUnmuteDrawerContext();

	return (
		<Alert variant="info">
			<strong className="font-semibold">{`There are ${ruleCount} silencing rules`}</strong> active on this monitor - you
			have to go through them and remove them individually. To learn more about unmuting monitors,{" "}
			<DocLink capture="noop" slug={SILENCING_DOC_LINK_SLUG}>
				check out our docs
			</DocLink>
			.
		</Alert>
	);
}
